import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

// The redemption video itself lives in the required_videos config table
// (video_key="redemption"). Admin updates the real Loom ID there once it
// exists; until then the unified RequiredVideo renders a placeholder and
// auto-unlocks the gate so the flow stays testable.

export function RulesBlurb(): ReactNode {
  return (
    <ul className="space-y-1 text-sm leading-relaxed text-text-secondary">
      <li>
        <strong className="text-text-primary">24 horas</strong> para añadir{' '}
        <strong className="text-text-primary">99 creadores</strong>.
      </li>
      <li>
        Durante esta ventana,{' '}
        <strong className="text-brand-red">no ganas dinero</strong> por los
        creadores que añadas.
      </li>
      <li>
        Si llegas, recuperas tu cuenta. Si no llegas, baneado para siempre.
      </li>
    </ul>
  );
}

type ActionsProps = {
  watched: boolean;
  startPending: boolean;
  onStart: () => void;
  onForfeit: () => void;
};

export function Actions(p: ActionsProps): ReactNode {
  return (
    <div className="space-y-sm">
      <Button
        variant="primary"
        size="lg"
        className="w-full"
        onClick={p.onStart}
        disabled={!p.watched || p.startPending}
      >
        {p.startPending ? 'Iniciando...' : 'Intentar redención'}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="w-full"
        onClick={p.onForfeit}
        disabled={p.startPending}
      >
        Salir del juego
      </Button>
    </div>
  );
}
